import { Paper, Typography } from "@mui/material";
import React from "react";
import type { Testimonial } from "../content/roleFaqsContent";

interface TestimonialCardProps {
  testimonial: Testimonial;
  /** Optional elevation override; default 1 */
  elevation?: number;
  /** Optional sx for the Paper root */
  sx?: object;
}

/**
 * Reusable single testimonial card: quote, author (person), and optional role (title).
 * Used in role FAQ TestimonialsSection and homepage.
 */
const TestimonialCard: React.FC<TestimonialCardProps> = ({
  testimonial,
  elevation = 1,
  sx = {},
}) => {
  const { quote, author, role } = testimonial;
  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 3,
        borderLeft: 4,
        borderColor: "primary.main",
        height: "100%",
        ...sx,
      }}
    >
      <Typography
        variant="body1"
        sx={{ fontStyle: "italic", lineHeight: 1.8, mb: 1.5 }}
      >
        &ldquo;{quote}&rdquo;
      </Typography>
      <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "primary.main" }}>
        — {author}
      </Typography>
      {role ? (
        <Typography variant="caption" color="text.secondary" display="block">
          {role}
        </Typography>
      ) : null}
    </Paper>
  );
};

export default TestimonialCard;
